<template>

    <div class="row text-start">
        <div class="col-lg-5 checkout-content" style="min-height:300px; padding-left:30px;padding-top:10px;" :style="{'background-image': 'url(' + Store.Checkout.BackgroundImage + ')'}">
            <div class="text-start text-muted fw-bold small"><i class="bi-cart-check" style="color:black;"></i> Your Order:</div>
            <h5 style="color:black;margin-left:15px;">
                Courier Delivery
            </h5>


            <div class="text-start text-muted fw-bold small">Pricing:</div>
            <div style="font-size:12px;" class="">
                <table class="mt-2" style="font-size: 10px; font-weight: bold; width: 100%; margin-left: 15px;">
                    <tr v-if="CourierConfig.initialFeeIsPerLocation">
                        <td>Pick-Up Fee:</td>
                        <td class="fw-bold" style="color:limegreen">${{CourierConfig.courierFeeInitial.toFixed(2)}}</td>
                    </tr>

                    <tr v-if="!CourierConfig.initialFeeIsPerLocation">
                        <td>Standard 1st Mile (Standard):</td>
                        <td class="fw-bold" style="color:limegreen">${{(CourierConfig.courierFeeInitial + CourierConfig.courierFeePerMileStandard).toFixed(2)}}</td>
                    </tr>
                    <tr>
                        <td>Standard Delivery Mileage:</td>
                        <td class="fw-bold" style="color:limegreen">${{CourierConfig.courierFeePerMileStandard.toFixed(2)}} /mile</td>
                    </tr>

                    <tr v-if="!CourierConfig.initialFeeIsPerLocation">
                        <td>Express 1st Mile:</td>
                        <td class="fw-bold" style="color:limegreen">${{(CourierConfig.courierFeeInitial + CourierConfig.courierFeePerMileExpress).toFixed(2)}}</td>
                    </tr>
                    <tr v-if="CourierConfig.offerExpressDelivery">
                        <td>Express Delivery Fee:</td>
                        <td class="fw-bold" style="color:limegreen">${{CourierConfig.courierFeePerMileExpress.toFixed(2)}} /mile</td>
                    </tr>


                    <tr>
                        <td></td>
                        <td></td>
                    </tr>

                    <tr v-if="CourierConfig.offerExpressDelivery">
                        <td>Max Item Dimensions:</td>
                        <td class="fw-bold" style="color:limegreen">{{CourierConfig.maxItemHeight}}" x {{CourierConfig.maxItemWidth}}" x {{CourierConfig.maxItemLength}}"</td>
                    </tr>
                    <tr v-if="CourierConfig.offerExpressDelivery">
                        <td>Max Item Weight:</td>
                        <td class="fw-bold" style="color:limegreen">{{CourierConfig.maxItemWeight}} lbs</td>
                    </tr>

                </table>
            </div>

            <div class="text-start text-muted fw-bold small" style="margin-top:20px">Note:</div>
            <ul class="" v-bind:style="{'color': CourierConfig.allowResidentialPickups ? 'blue' : 'red'}" style="list-style: none; font-size: 12px; padding-left: 15px; margin-bottom:0; ">
                <li v-if="!CourierConfig.allowResidentialPickups"><i class="bi-exclamation-triangle"></i>&nbsp; At this time <span class="fw-bold">residential address pick-up locations are not serviced.</span> If you enter a residential address, your pick-up will be canceled. Residential addresses may, however, still be used for drop-offs/destinations.</li>
                <li v-if="CourierConfig.allowResidentialPickups"><i class="bi-info-circle"></i>&nbsp; Both <span class="fw-bold">residential and commerical addresses</span> are accepted for both pick-up and drop-off.</li>
            </ul>

            <div class="mb-3 mt-3">
                <img src="/images/courierfrill.png" style="width:100%" />
            </div>
        </div>
        <div class="col-lg-7 p-3" style="border-left:1px solid lightgrey">

            <div class="position-relative text-center pa-3 shadow-sm" style="top:10px;">

                <div class="h5 fw-semibold text-capitalize light-info" style="">Pick-Up Location*</div>
                <!-- Input Card -->
                <input autofocus @input="AddressModded = true" v-model="Store.Checkout.Cart.StartAddress" type="text" class="form-control form-control-sm" id="fnAddress" placeholder="<enter full address>" aria-label="full address">
                <div class="blink text-red fw-bold text-center mt-2" v-if="StartError">{{StartError}}</div>
                <!-- End Input Card -->
            </div>

            <div class="position-relative text-center p-3  shadow-sm mt-5" style="">

                <div class="h5 text-muted fw-semibold text-capitalize light-info">How Many Items Are You Sending?</div>
                <select v-model.number="NumCourierItemsSending" class="form-select form-select-sm">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                </select>
            </div>

            <div class="position-relative text-center p-0 mt-3" style="">

                <div class="h5 mt-4 text-muted fw-semibold text-capitalize light-info">Enter Destination Info*</div>

                <template v-for="(item, idx) in Store.Checkout.Cart.DeliveryItemInfo" :key="idx">

                    <div class="m-0 text-start" style="">
                        <transition name="flip">
                            <div class="card mb-1 shadow-sm rounded-0">
                                <div class="card-body" style="padding:5px;padding-top:15px;">
                                    <div class="row no-gutters">
                                        <div class="col-1">
                                            <div class="numberCircle">#{{idx+1}}</div>
                                        </div>
                                        <div class="col-10">
                                            <h3 class="card-title h5" style="padding-left:5px;">Item #{{idx+1}} Delivery Info</h3>
                                        </div>
                                        <div class="col-1" v-if="Store.Checkout.Cart.DeliveryItemInfo && Store.Checkout.Cart.DeliveryItemInfo.length > 1">
                                            <a @click="RemoveCourierItem(idx)" href="javascript:void(0)" style="color:red" title="Remove"><i class="bi bi-trash"></i></a>
                                        </div>
                                    </div>

                                    <div class="row mb-2">
                                        <div class="col-12">
                                            <label class="form-label mb-0 small">Recipient Name*</label>
                                            <input @input="AddressModded = true" v-model="item.RecipientName" type="text" class="form-control form-control-sm" placeholder="Name">
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-6">
                                            <label class="form-label mb-0 small">Street Address*</label>
                                            <input @input="AddressModded = true" v-model="item.Street1" type="text" class="form-control form-control-sm" placeholder="Street address">
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label mb-0 small">Address 2</label>
                                            <input @input="AddressModded = true" v-model="item.Street2" type="text" class="form-control form-control-sm" placeholder="Apt, Suite, etc.">
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-5">
                                            <label class="form-label mb-0 small">City*</label>
                                            <input @input="AddressModded = true" v-model="item.City" type="text" class="form-control form-control-sm" placeholder="City">
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label mb-0 small">State*</label>
                                            <input @input="AddressModded = true" v-model="item.State" type="text" class="form-control form-control-sm" placeholder="State" maxlength="2">
                                        </div>
                                        <div class="col-md-4">
                                            <label class="form-label mb-0 small">Zip*</label>
                                            <input @input="AddressModded = true" v-model="item.Zip" type="text" class="form-control form-control-sm" placeholder="Zip">
                                        </div>
                                    </div>

                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text" id=""><i class="bi-pencil-fill"></i>&nbsp; Instructions (opt)</span>
                                        <input @input="AddressModded = true" maxlength="1024" v-model="item.Instructions" type="text" class="form-control form-control-sm">
                                    </div>

                                    <div class="row" v-show="CourierItemsReadyForCheckout">

                                        <div class="col col-12 col-md-6">
                                            <label class="form-check form-check-select form-check-pinned-top-end" :for="'formCheckPinnedEgF' + idx">
                                                <input type="radio" class="form-check-input" :value="false" :id="'formCheckPinnedEgF' + idx" v-model="item.Express">
                                                <span class="form-check-label">
                                                    <span class="h4 mb-0" v-if="item.Cost">${{item.Cost.toFixed(2)}}</span>
                                                    <span class="fw-medium" v-if="item.Cost">&nbsp; Standard</span>
                                                    <span class="fw-medium" v-if="!item.Cost">&nbsp; Standard Delivery</span>
                                                </span>
                                                <span class="form-check-stretched-bg"></span>
                                            </label>
                                            <div class="text-center">
                                                <a style="font-size:10px;" @click="ViewCourierTerms(CourierConfig.standardDeliveryTerms)" href="javascript:void(0);" class="link-info text-muted">(standard terms)</a>
                                            </div>
                                            <!-- End Radio Check -->
                                        </div>

                                        <div class="col col-12 col-md-6">
                                            <!-- Radio Check -->
                                            <label class="form-check form-check-select form-check-pinned-top-end" :for="'formCheckPinnedEgT' + idx">
                                                <input type="radio" class="form-check-input" :value="true" :id="'formCheckPinnedEgT' + idx" v-model="item.Express">
                                                <span class="form-check-label">
                                                    <span class="h4 mb-0" v-if="item.CostExpress">${{item.CostExpress.toFixed(2)}}</span>
                                                    <span class="fw-medium" v-if="item.CostExpress">&nbsp; Express</span>
                                                    <span class="fw-medium" v-if="!item.CostExpress">&nbsp; Express Delivery</span>
                                                </span>
                                                <span class="form-check-stretched-bg"></span>
                                            </label>
                                            <div class="text-center">
                                                <a style="font-size:10px;" @click="ViewCourierTerms(CourierConfig.expressDeliveryTerms)" href="javascript:void(0);" class="link-info text-muted">(express terms)</a>
                                            </div>
                                            <!-- End Radio Check -->
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col text-center">
                                            <span class="small blink" style="color:red;" v-if="item.Error"><i class="bi bi-exclamation-triangle"></i>&nbsp;{{item.Error}}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </transition>





                    </div>
                </template>

                <div class="card mb-1 shadow-sm" v-if="CourierItemsReadyForCheckout">
                    <div style="padding:5px;font-size:10px;" class="card-header text-center text-muted small fst-italic text-uppercase">Delivery Terms</div>
                    <div class="card-body" style="padding:5px;">
                        <div class="row text-center" v-if="CourierTotal">
                            <div class="col-12 text-primary" style="font-weight:bold;font-size:26px;">
                                Total: <span>${{CourierTotal.toFixed(2)}}</span>
                                       <div v-if="Store.Checkout.Cart.CourierPickupFee">
                                           <span style="font-size:12px;" class="text-muted fw-normal">(includes ${{Store.Checkout.Cart.CourierPickupFee.toFixed(2)}} pick-up fee)</span>
                                       </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-center" v-if="CourierItemsReadyForCheckout && HaveExpressCourierItems">
                                <a @click="ViewCourierTerms(CourierConfig.expressDeliveryTerms)" href="javascript:void(0);" class="link-info"><i class="bi-info-circle"></i> Express Delivery Terms</a>
                            </div>
                            <div class="col text-center" v-if="CourierItemsReadyForCheckout && HaveStandardCourierItems">
                                <a @click="ViewCourierTerms(CourierConfig.standardDeliveryTerms)" href="javascript:void(0);" class="link-info"><i class="bi-info-circle"></i> Standard Delivery Terms</a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div data-bs-keyboard="false" style="z-index:300;" id="MessageModalCourierTerms" class="modal" tabindex="-1" role="dialog" aria-labelledby="Modal Message" aria-hidden="true">
        <div class="modal-dialog" style="margin-bottom: 150px;" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="" style="">
                        <h4 class="modal-title h4" style="margin: 0 auto !important;" v-html="ModalTitle"></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row mb-2 text-start">
                        <div class="col text-muted" style="font-size:14px;">
                            {{DeliveryTermsViewing}}
                        </div>
                    </div>
                    <hr style="margin-bottom:5px;margin-top:5px;" />

                    <div class="row mb-5">
                        <div class="col-12" style="padding-right:0;">
                            <div class="d-grid gap-0">
                                <button @click="HideCourierTerms" type="button" class="btn btn-sm btn-light shadow btn-block" style="border-radius:0;">Done</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { useEditorStore } from '/src/stores/EditorStore';
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'VenueSelectFieldNotary',
        components: {
        },
        watch:{
            'Store.Checkout.Cart.CurrentStep': function(newVal, oldVal) {
                if (newVal === 1 && oldVal > 1) {
                    // Returning to this step from a later step
                    // Decode address fields back to individual fields if they're encoded
                    if (this.Store.Checkout.Cart.DeliveryItemInfo) {
                        this.Store.Checkout.Cart.DeliveryItemInfo.forEach(item => {
                            if (item.AddressFields) {
                                const decoded = this.decodeAddress(item.AddressFields);
                                Object.assign(item, decoded);
                            }
                        });
                    }
                }
            },
            CourierItemsReadyForCheckout: function (newVal, oldVal) {
                this.Store.Checkout.NextButton.IsVisible = true;
                if (newVal != true) {
                    this.Store.Checkout.NextButton.Text = "Validate Addresses & Get Pricing";
                    this.Store.Checkout.NextButton.Icon = "bi-geo-alt";
                }
                else {
                    this.Store.Checkout.NextButton.Text = `Schedule Pick-Up`;
                    this.Store.Checkout.NextButton.Icon = "bi-calendar-check";
                }
            },         
            
        },
        props: {
        },
        data() {
            return {
                UpdatingDeliveryItems: false,
                ModalTitle: '',
                AddressModded: false,
                Store: {},
                StartError: '',
                DeliveryTermsViewing: '',
                InitialCartLoaded: false,
            };
        },
        methods:
        {
            encodeAddress(item) {
                // Encode address in the format: Name|Street1,Street2,City,State,Zip,Country
                // Note: Country is always USA for courier services
                const name = (item.RecipientName || '').trim();
                const street1 = (item.Street1 || '').trim();
                const street2 = (item.Street2 || '').trim();
                const city = (item.City || '').trim();
                const state = (item.State || '').trim().toUpperCase();
                const zip = (item.Zip || '').trim();
                
                return `${name}|${street1},${street2},${city},${state},${zip},United States of America`;
            },
            decodeAddress(encodedAddress) {
                // Decode address from format: Name|Street1,Street2,City,State,Zip,Country
                if (!encodedAddress) return {};
                
                const parts = encodedAddress.split('|');
                if (parts.length !== 2) return {};
                
                const name = parts[0].trim();
                const addressParts = parts[1].split(',');
                
                return {
                    RecipientName: name,
                    Street1: addressParts[0]?.trim() || '',
                    Street2: addressParts[1]?.trim() || '',
                    City: addressParts[2]?.trim() || '',
                    State: addressParts[3]?.trim() || '',
                    Zip: addressParts[4]?.trim() || '',
                    Country: addressParts[5]?.trim() || 'United States of America'
                };
            },
            validateAddress(item) {
                const requiredFields = [
                    { field: 'RecipientName', label: 'Recipient Name' },
                    { field: 'Street1', label: 'Street Address' },
                    { field: 'City', label: 'City' },
                    { field: 'State', label: 'State' },
                    { field: 'Zip', label: 'Zip Code' }
                ];
                
                const missingFields = requiredFields.filter(f => !item[f.field] || !item[f.field].trim());
                
                if (missingFields.length > 0) {
                    const missingLabels = missingFields.map(f => f.label).join(', ');
                    return { valid: false, error: `Missing required fields: ${missingLabels}` };
                }
                
                // Validate state is 2 characters
                if (item.State && item.State.trim().length !== 2) {
                    return { valid: false, error: 'State must be 2 characters' };
                }
                
                // Validate zip code format (basic US zip validation)
                const zipRegex = /^\d{5}(-\d{4})?$/;
                if (!zipRegex.test(item.Zip.trim())) {
                    return { valid: false, error: 'Invalid zip code format' };
                }
                
                return { valid: true };
            },
            OnCartLoaded: function () {
                if (this.Store.Checkout.Cart.SelectedService !== 'CourierDelivery') {
                    return;
                }

                var isInitialLoad = !this.InitialCartLoaded;
                this.InitialCartLoaded = true;

                // Initialize and decode addresses if they exist
                if (this.Store.Checkout.Cart.DeliveryItemInfo) {
                    this.Store.Checkout.Cart.DeliveryItemInfo.forEach(item => {
                        // Initialize missing fields first
                        if (!item.hasOwnProperty('RecipientName')) item.RecipientName = '';
                        if (!item.hasOwnProperty('Street1')) item.Street1 = '';
                        if (!item.hasOwnProperty('Street2')) item.Street2 = '';
                        if (!item.hasOwnProperty('City')) item.City = '';
                        if (!item.hasOwnProperty('State')) item.State = '';
                        if (!item.hasOwnProperty('Zip')) item.Zip = '';

                        // If we have encoded address fields but no individual fields, decode them
                        if (item.AddressFields && !item.RecipientName) {
                            const decoded = this.decodeAddress(item.AddressFields);
                            Object.assign(item, decoded);
                        }

                        // On initial page load, reset pricing so user must re-validate with fresh tenant settings
                        if (isInitialLoad) {
                            item.Valid = false;
                            item.Cost = 0;
                            item.CostExpress = 0;
                            item.Error = '';
                        }
                    });

                    if (isInitialLoad) {
                        // Reset pickup fee and cart price
                        this.Store.Checkout.Cart.CourierPickupFee = 0;
                        this.Store.Checkout.Cart.Price = 0;

                        // Regress to venue step so user re-validates
                        if (this.Store.Checkout.Cart.CurrentStep > 1) {
                            this.Store.SetCurrentStep(1);
                        }
                    }
                } else {
                    // Initialize with one empty item if none exist
                    this.Store.Checkout.Cart.DeliveryItemInfo = [{
                        Idx: 0,
                        Express: false,
                        Address: "",
                        RecipientName: "",
                        Street1: "",
                        Street2: "",
                        City: "",
                        State: "",
                        Zip: "",
                        Instructions: "",
                        Error: "",
                        Valid: false,
                        Miles: 0,
                        Cost: 0,
                        CostExpress: 0
                    }];
                }
            },
            OnStepActivated: async function(){
                if(this.Store.Checkout.Cart.CurrentStep == 1){
                    // Initialize delivery items if needed
                    if (this.Store.Checkout.Cart.DeliveryItemInfo && this.Store.Checkout.Cart.DeliveryItemInfo.length > 0) {
                        this.Store.Checkout.Cart.DeliveryItemInfo.forEach(item => {
                            // Initialize missing fields
                            if (!item.hasOwnProperty('RecipientName')) item.RecipientName = '';
                            if (!item.hasOwnProperty('Street1')) item.Street1 = '';
                            if (!item.hasOwnProperty('Street2')) item.Street2 = '';
                            if (!item.hasOwnProperty('City')) item.City = '';
                            if (!item.hasOwnProperty('State')) item.State = '';
                            if (!item.hasOwnProperty('Zip')) item.Zip = '';
                        });
                    }
                }
            },
            OnCmdNext: async function () {
                if(this.Store.Checkout.Cart.CurrentStep != 1){
                    return;
                }

                if (this.Store.Checkout.Cart.SelectedService == "CourierDelivery") {
                    // First check if we have pricing already calculated
                    if (!this.CourierItemsReadyForCheckout){
                        // Validate pickup address
                        if (!this.Store.Checkout.Cart.StartAddress || this.Store.Checkout.Cart.StartAddress.trim() === '') {
                            nextTick().then(() => {
                                this.StartError = "Pick-up address can't be blank.";
                            });

                            toast.error("Pick-up address can't be blank.");
                            return;
                        } else {
                            this.StartError = '';
                        }
                        
                        // Validate and get pricing
                        await this.ValidateAndDisplayDeliveries();
                        return;
                    }
                    else{
                        // We have pricing, proceed to next step
                        // Keep addresses in Google format - encoding will be handled server-side
                        this.Store.Checkout.Cart.Price = this.CourierTotal;
                        this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) + 1)
                    }
                }

            },
            ViewCourierTerms: function (terms) {
                this.DeliveryTermsViewing = terms;
                var modal = bootstrap.Modal.getOrCreateInstance('#MessageModalCourierTerms');
                if (modal) {
                    modal.show();
                }
            },
            HideCourierTerms: function () {
                var modal = bootstrap.Modal.getOrCreateInstance('#MessageModalCourierTerms');
                if (modal) {
                    modal.hide();
                }
            },
            RemoveCourierItem: function (idx) {
                if (idx >= 0 && idx < this.Store.Checkout.Cart.DeliveryItemInfo.length) {
                    // Ensure idx is within the bounds of the array
                    this.Store.Checkout.Cart.DeliveryItemInfo.splice(idx, 1);
                    // The splice method removes 1 element starting from the idx position
                }
                
            },
            ValidateAndDisplayDeliveries: async function (start) {
                EventHub.$emit("WizLoading", true);

                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                var that = this;
                
                // First validate all addresses
                let hasValidationErrors = false;
                that.Store.Checkout.Cart.DeliveryItemInfo.forEach((item, idx) => {
                    item.Error = "";
                    const validation = that.validateAddress(item);
                    if (!validation.valid) {
                        item.Error = validation.error;
                        hasValidationErrors = true;
                    } else {
                        // Create Google Maps friendly address string for server-side geocoding
                        const street = item.Street2 ? `${item.Street1} ${item.Street2}` : item.Street1;
                        item.Address = `${street}, ${item.City}, ${item.State} ${item.Zip}`.trim();
                    }
                });
                
                if (hasValidationErrors) {
                    EventHub.$emit("WizLoading", false);
                    toast.error("Please fix address errors before continuing.");
                    return;
                }

                // ajax to server to get distance and cost estimate
                axios.postForm('/API/GetCourierDeliveryServiceEstimateMult',
                    {
                        StartAddress: this.Store.Checkout.Cart.StartAddress,
                        deliveries: this.Store.Checkout.Cart.DeliveryItemInfo
                    }, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {

                    EventHub.$emit("WizLoading", false);

                    if (response.data.success) {
                        that.StartError = '';
                        that.UpdatingDeliveryItems = true;
                        // Merge response data with existing address fields and user instructions
                        response.data.items.forEach((respItem, idx) => {
                            if (that.Store.Checkout.Cart.DeliveryItemInfo[idx]) {
                                const currentItem = that.Store.Checkout.Cart.DeliveryItemInfo[idx];
                                respItem.RecipientName = currentItem.RecipientName;
                                respItem.Street1 = currentItem.Street1;
                                respItem.Street2 = currentItem.Street2;
                                respItem.City = currentItem.City;
                                respItem.State = currentItem.State;
                                respItem.Zip = currentItem.Zip;
                                respItem.Instructions = currentItem.Instructions;
                                // Store structured address fields for session round-trip (Address stays in Google Maps format for server)
                                respItem.AddressFields = that.encodeAddress(currentItem);
                            }
                        });
                        that.Store.Checkout.Cart.DeliveryItemInfo = response.data.items;
                        that.Store.Checkout.Cart.CourierPickupFee = response.data.pickupfee;
                        if (response.data.items.some(item => item.Valid == false)) {
                            toast.error("Please fix address errors before continuing to scheduling.");
                        } else {
                            toast.info("Looks good! Please review your delivery costs and confirm delivery speed decisions before clicking to 'Schedule Pick-Up'.", { position: toast.POSITION.BOTTOM_CENTER, transition: 'slide', autoClose: 10000 });
                        }
                        that.AddressModded = false;
                        that.UpdatingDeliveryItems = false;                        
                    }
                    else {
                        // Server returned an error (e.g., pickup address invalid or outside service area)
                        that.StartError = response.data.msg || "Address validation failed. Please check your addresses and try again.";
                        toast.error(response.data.msg || "Address validation failed.");
                    }
                }).catch(function (error) {
                    EventHub.$emit("WizLoading", false);
                    toast.error("There was an error. Please refresh the page and try again.");
                });
            },
        },
        computed:
        {
            NumCourierItemsSending: {
              get() {
                return this.Store.Checkout.Cart.DeliveryItemInfo.length;
              },
              set(newVal) {
                 const defaultDeliveryItem = {
                        Idx: 0,
                        Express: false,
                        Address: "",
                        RecipientName: "",
                        Street1: "",
                        Street2: "",
                        City: "",
                        State: "",
                        Zip: "",
                        Instructions: "",
                        Error: "",
                        Valid: false,
                        Miles: 0,
                        Cost: 0,
                        CostExpress: 0
                    };
                    if (newVal > this.Store.Checkout.Cart.DeliveryItemInfo.length) {
                        const elementsToAdd = newVal - this.Store.Checkout.Cart.DeliveryItemInfo.length;
                        const startingIdx = this.Store.Checkout.Cart.DeliveryItemInfo.length;

                        for (let i = 0; i < elementsToAdd; i++) {
                            defaultDeliveryItem.Idx = startingIdx + i;
                            this.Store.Checkout.Cart.DeliveryItemInfo.push({ ...defaultDeliveryItem });
                        }
                    }
                    // If newVal is less than the current number of elements
                    else if (newVal < this.Store.Checkout.Cart.DeliveryItemInfo.length) {
                        const elementsToRemove = this.Store.Checkout.Cart.DeliveryItemInfo.length - newVal;
                        for (let i = 0; i < elementsToRemove; i++) {
                            this.Store.Checkout.Cart.DeliveryItemInfo.pop();
                        }
                    }
              }
            },
            CourierTotal: function(){
                if(!this.Store.DeliveryItemInfo || !this.Store.DeliveryItemInfo.length)
                {
                    var total = 0;
                    this.Store.Checkout.Cart.DeliveryItemInfo.forEach(item => {
                        var amt = item.Express? item.CostExpress : item.Cost;;
                        total += amt;
                    });

                    total += this.Store.Checkout.Cart.CourierPickupFee;

                    return total;
                }
            },
            HaveExpressCourierItems: function () {
                return this.Store.Checkout.Cart.DeliveryItemInfo.some(item => item.Express == true);
            },
            HaveStandardCourierItems: function () {
                return this.Store.Checkout.Cart.DeliveryItemInfo.some(item => item.Express == false);
            },
            TotalCourierDeliveryCharge: function () {
                return this.Store.Checkout.Cart.DeliveryItemInfo.reduce((total, item) => {
                    if (item.Valid) {
                        total += item.Express ? item.CostExpress : item.Cost;
                    }
                    return total;
                }, 0);
            },
            CourierItemsReadyForCheckout: function () {
                if (!this.Store || !this.Store.Checkout) {
                    return false;
                }
                var res = this.Store.Checkout.Cart.SelectedService == 'CourierDelivery' && this.Store.Checkout.Cart.DeliveryItemInfo.every(item => item.Valid == true) && this.CourierTotal > 0;
                res = res && !this.AddressModded;
                return res;
            },
            CourierConfig: function () {
                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigCourier) {
                    return this.Store.TenantConfig.serviceConfigCourier;
                }

                return {};
            },
        },
        beforeMount: function () {

        },
        created: function () {
            this.Store = useEditorStore();
        },
        activated() {
            this.Store.Checkout.NextButton.Text = "Validate Addresses & Get Pricing";
            this.Store.Checkout.NextButton.Icon = "bi-geo-alt";
            this.Store.Checkout.NextButton.IsVisible = true;  
        },
        mounted: function () {
            //this.NumCourierItemsSending = 0
            EventHub.$on('OnStepActivated', this.OnStepActivated);
            EventHub.$on('OnCmdNext', this.OnCmdNext);  
            EventHub.$on('CartLoaded', this.OnCartLoaded);              
        },
        beforeUnmount: function () {
            EventHub.$off('OnStepActivated', this.OnStepActivated);
            EventHub.$off('OnCmdNext', this.OnCmdNext);
            EventHub.$off('CartLoaded', this.OnCartLoaded);
        }
    }
</script>

<style>
  
</style>